"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeprecatedSocialCallback = useDeprecatedSocialCallback;
var React = _interopRequireWildcard(require("react"));
var _social = require("../../../actions/social");
var _events = require("../../../actions/events");
var _social2 = require("../../../types/social");
var _events2 = require("../../../types/events");
var _tracking = require("../../../utils/tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* TODO переписать это всё */
function useDeprecatedSocialCallback(useDispatch, source) {
  const dispatch = useDispatch();
  const handleSocialSuccess = type => {
    return (socialLoginId, email, token, userCreated) => {
      dispatch((0, _social.authenticate)({
        socialType: type,
        socialLoginId,
        email,
        token,
        userCreated,
        source
      }));
    };
  };
  const handleSocialEmailRequired = (socialType, socialLoginId) => {
    dispatch((0, _social.authenticateEmailRequired)({
      socialLoginId,
      socialType,
      email: '',
      phone: ''
    }));
  };
  const handleSocialEmailTaken = (email, socialLoginId, socialType) => {
    dispatch((0, _social.authenticateEmailTaken)({
      email,
      socialLoginId,
      socialType
    }));
  };
  const handleSocialError = type => {
    return () => {
      dispatch((0, _social.authenticateError)(type));
    };
  };
  const handleSocialResponse = function () {
    for (var _len = arguments.length, response = new Array(_len), _key = 0; _key < _len; _key++) {
      response[_key] = arguments[_key];
    }
    const [type, data] = response;
    switch (type) {
      case _social2.ESocialResponseType.UserNotFound:
        {
          const {
            socialLoginId,
            socialType,
            email,
            phone
          } = data;
          dispatch((0, _social.authenticateEmailRequired)({
            socialLoginId,
            socialType,
            email,
            phone
          }));
          break;
        }
    }
  };
  const handleSocialClick = React.useCallback(socialType => {
    window._socialResponse = handleSocialResponse;

    /* DEPRECATED */
    window.socialLogOnStart = handleSocialSuccess(socialType);
    window.showNeedEmailPopup = handleSocialEmailRequired;
    window.showNeedMergeEmailPopup = handleSocialEmailTaken;
    window.showErrorSocialAuth = handleSocialError(socialType);
    dispatch((0, _events.emit)(_events2.EEventType.SocialButtonClick, {
      type: socialType
    }));
    dispatch((0, _social.open)({
      socialType
    }));
    (0, _tracking.trackSocialButtonClick)(socialType, source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return handleSocialClick;
}